import StoreUtil from '@/store/StoreUtil'

export default {
  FETCH_USER: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'fetchUser'
  ),
  LOG_IN: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'logIn'),
  LOG_OUT: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'logOut'),
  REGISTER: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'register'),
  FORGOT_PASSWORD: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'forgotPassword'
  ),
  RESET_PASSWORD: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'resetPassword'
  ),
  FETCH_PROFILE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'fetchProfile'
  ),
  UPDATE_PROFILE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'updateProfile'
  ),
  GET_PAYMENT_METHOD: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'getPaymentMethod'
  ),
}
